import {
  campaignIcon,
  giftIcon,
  hornIcon,
  interactionIcon,
} from '@/assets/images';
import EntityContentType from '@/constants/EntityContentType';
import translate from '@/lib/intl/translate';
import colors from '@/styles/themeColors';

const EntitySummaries: {
  [k: string]: {
    color: string;
    icon: string;
    label: string;
  };
} = {
  [EntityContentType.ANNOUNCEMENT]: {
    color: colors.feedAnnouncement,
    icon: hornIcon,
    label: translate('FEED_ANNOUNCEMENT_LABEL'),
  },
  [EntityContentType.DONATION]: {
    color: colors.feedDonation,
    icon: giftIcon,
    label: translate('FEED_CONTRIBUTION_LABEL'),
  },
  [EntityContentType.CAMPAIGN_CREATED]: {
    color: colors.feedCampaign,
    icon: campaignIcon,
    label: translate('FEED_CAMPAIGN_LABEL'),
  },
  [EntityContentType.CAMPAIGN_GOAL_MET]: {
    color: colors.feedCampaign,
    icon: campaignIcon,
    label: translate('FEED_CAMPAIGN_LABEL'),
  },
  [EntityContentType.CAMPAIGN_STRETCH_GOAL_ADDED]: {
    color: colors.feedCampaign,
    icon: campaignIcon,
    label: translate('FEED_CAMPAIGN_LABEL'),
  },
  [EntityContentType.CAMPAIGN_STRETCH_GOAL_MET]: {
    color: colors.feedCampaign,
    icon: campaignIcon,
    label: translate('FEED_CAMPAIGN_LABEL'),
  },
  [EntityContentType.EMAIL_RECEIVED]: {
    color: colors.feedInteraction,
    icon: interactionIcon,
    label: translate('FEED_INTERACTION_LABEL'),
  },
  [EntityContentType.EMAIL_SENT]: {
    color: colors.feedInteraction,
    icon: interactionIcon,
    label: translate('FEED_INTERACTION_LABEL'),
  },
  [EntityContentType.INTERACTION]: {
    color: colors.feedInteraction,
    icon: interactionIcon,
    label: translate('FEED_INTERACTION_LABEL'),
  },
};

export default EntitySummaries;
